import { useEffect, useState } from 'react';
import { LockIcon } from 'lucide-react';
import { FloatingBar } from '../layout/FloatingBar';
import { btnPriceAmount, btnPriceBar, btnPriceLabel } from '../../ui/styles';
import { euroCents } from './checkoutRules';
type Props = {
  /** Het formulier dat deze knop verstuurt (dezelfde controle als de knop onderaan). */
  formId: string;
  /** De echte bestelknop: staat die in beeld, dan is deze balk overbodig. */
  submitId: string;
  totalCents: number;
  disabled: boolean;
};

/**
 * Telefoon: het totaal en "Bestellen en betalen" blijven onderin bij de hand, want het formulier is
 * lang en de knop staat helemaal onderaan. Weg zodra de echte knop in beeld is, en zolang een veld
 * focus heeft: anders schuift de balk mee boven het toetsenbord en bedekt hij wat je typt.
 */
export function CheckoutPayBar({
  formId,
  submitId,
  totalCents,
  disabled
}: Props) {
  // Alleen tonen zolang de echte knop nog ónder het scherm ligt. Voorbij de knop (bij de footer) niet:
  // afrekenen heeft geen ruimte onderaan gereserveerd, dus anders bedekt de balk de juridische links.
  const [submitBelow, setSubmitBelow] = useState(false);
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const el = document.getElementById(submitId);
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(([entry]) => setSubmitBelow(Boolean(entry && !entry.isIntersecting && entry.boundingClientRect.top > 0)), {
      rootMargin: '0px 0px -40px 0px'
    });
    io.observe(el);
    return () => io.disconnect();
  }, [submitId]);
  useEffect(() => {
    const isField = (el: EventTarget | null) => el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement;
    const onIn = (e: FocusEvent) => setTyping(isField(e.target));
    // Van veld naar veld (Volgende op het toetsenbord) geeft eerst focusout en dan focusin: zonder een
    // korte wachttijd flitst de balk er tussendoor even in.
    let t: number | undefined;
    const onOut = () => {
      window.clearTimeout(t);
      t = window.setTimeout(() => setTyping(isField(document.activeElement)), 100);
    };
    document.addEventListener('focusin', onIn);
    document.addEventListener('focusout', onOut);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener('focusin', onIn);
      document.removeEventListener('focusout', onOut);
    };
  }, []);
  const show = submitBelow && !typing;
  return <FloatingBar show={show} data-id="element-7003" data-mp="1k1d99iy62god">
      <button type="submit" form={formId} disabled={disabled} className={btnPriceBar} data-id="element-7004" data-mp="1k0bub3e15a1d">
        <span className={btnPriceLabel} data-id="element-7005" data-mp="1xsrt1rzwelwh">
          <LockIcon className="h-4 w-4 shrink-0" strokeWidth={1.5} aria-hidden="true" data-id="element-7006" data-mp="1xumb8yjsbzwv" />
          {/* Wettelijk: ook hier moet duidelijk zijn dat je betaalt. */}
          Bestellen en betalen
        </span>
        <span className={btnPriceAmount} data-id="element-7007" data-mp="27objhyvp0sdu">{euroCents(totalCents)}</span>
      </button>
    </FloatingBar>;
}